import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Environement} from '../../../environement/environement';
import {removeAccents} from '../../partage/prototype/sansAccents';
@Injectable()
export class ListeContactService {
  private listeContactURL = Environement.BASE_API_URL + '/api/liste_contacts';
  private contactURL = Environement.BASE_API_URL + '/api/contacts';
  private gestionnaireURL = Environement.BASE_API_URL + '/api/gestionnaire_listes';
  private listeContactAssoURL = Environement.BASE_API_URL + '/api/liste_contact_contacts';
  private listeContactIntranetURL = Environement.BASE_API_URL + '/api/contacts/recherche/intranet/liste/';
  private typeURL = Environement.BASE_API_URL + '/api/type_listes';
  constructor(private http: HttpClient) {
  }
  getListeContactEscalnetByAncienID(listeContactAncienID) {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/liste_contacts?ancienId=' + listeContactAncienID,
      {headers: headers}).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListesContactsParDefaut(page) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '?_page=' + page + '&order[nom]=asc', {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addListeContactIntranet(listeContact) {
    const headers = this.initOptionHeader();
    return this.http.post(this.listeContactURL,
        {
          nom: listeContact.nom,
          commentaires: listeContact.commentaires,
          creation: listeContact.creation,
          modification: listeContact.modification,
          // auteur: listeContact.auteur,
          type: 'api/type_listes/' + parseInt(listeContact.type, 10),
          ancienId: listeContact.ancienId,
        },
      {headers}).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
  }

  addListeContact(listeContact, typeId) {
    let type = null;
    if (typeId != 0) {
      type = Environement.BASE_API_URL + '/api/type_listes/' + typeId;
    }
    const DateCre = listeContact.creation.getFullYear() + '-' + (listeContact.creation.getMonth() + 1).toString() + '-' + listeContact.creation.getDate() + ' ' + listeContact.creation.getHours() + ':' + listeContact.creation.getMinutes() + ':00' ;
    const headers = this.initOptionHeader();
    return this.http.post(this.listeContactURL, {'nom': listeContact.nom, 'type': type,
        'commentaires': listeContact.commentaires, 'creation' : DateCre,
        'auteur': Environement.BASE_API_URL + '/api/auth_users/' + listeContact.auteur.id},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addListeContactCopie(listeContact, typeId) {
    let type = null;
    if (typeId != 0) {
      type = Environement.BASE_API_URL + '/api/type_listes/' + typeId;
    }
    let nom = '';
    nom = 'Copie de ' + listeContact.nom;
    const headers = this.initOptionHeader();
    return this.http.post(this.listeContactURL, {'nom': nom, 'type': type,
        'commentaires': listeContact.commentaires, 'creation' : listeContact.creation, 'modification' : listeContact.modification,
        'auteur': Environement.BASE_API_URL + '/api/auth_users/' + listeContact.auteur.id},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addContactListe(listeId, contactId) {
    const headers = this.initOptionHeader();
    return this.http.post(this.listeContactAssoURL, {
        'listeContact': this.listeContactURL + '/' + listeId,
        'contact': this.contactURL + '/' + contactId},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getOneAssoContactListe(listeId, contactId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactAssoURL + '?listeContact.id=' + listeId + '&contact.id=' + contactId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  associerListeContact(listeId, contactAncienId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/associer/intranet/liste/contact/' + listeId + '/' + contactAncienId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  importerListeContactIntranet(listeId, ancienId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/importation/copie/liste/contact/' + listeId + '/' + ancienId,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getListeContactDetails(id): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/' + id , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  getAncienIdAuteur(listeParutionId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/auteur/intranet/' + listeParutionId , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAllContactsListe(listeId, page) {
    const headers = this.initOptionHeader();
    return this.http.get(this.contactURL + '?listeContactContacts.listeContact.id=' + listeId + '&_page=' + page + '&order[nom]=asc', {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListeAllContacts(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.contactURL + '?listeContactContacts.listeContact.id=' + listeId + '&pagination=false&order[nom]=asc', {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  associerContactListe(contactId, listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/associer/contact/liste/contacts/import/' + contactId + '/' + listeId,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  modifierListeContact(listeContact, typeId) {
    let type = null;
    if (typeId != 0) {
      type = Environement.BASE_API_URL + '/api/type_listes/' + typeId;
    }
    listeContact.modification = new Date();
    const DateModif = listeContact.modification.getFullYear() + '-' + (listeContact.modification.getMonth() + 1).toString() + '-' + listeContact.modification.getDate() + ' ' + listeContact.modification.getHours() + ':' + listeContact.modification.getMinutes() + ':00' ;
    const headers = this.initOptionHeader();
    return this.http.put(this.listeContactURL + '/' +  listeContact.id, {'nom': listeContact.nom,
        'commentaires': listeContact.commentaires, 'modification' : DateModif, 'type': type},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getDernierSuiviContact(contactId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/suivis?contact.id=' + contactId +  '&order[id]=desc', {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getOrganisationContactDetails(id): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/contact_organisations/' + id , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  getAllAssosListeContact(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactAssoURL + '?pagination=false&listeContact.id=' + listeId , {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  supprimerAssoListeContact(assoId) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeContactAssoURL + '/' +  assoId,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  getAllAssosGestionnaireListeContact(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.gestionnaireURL + '?pagination=false&listeContact.id=' + listeId , {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  supprimerGestionnaireListeContact(gestionnaireAssoId) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.gestionnaireURL + '/' +  gestionnaireAssoId,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  supprimerImportListeContactIntranet(ancienIdListe) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/importation/supprimer/copie/liste/contact/' + ancienIdListe ,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  supprimerListeContact(id) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeContactURL + '/' +  id,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListeContactIntranetByID(id) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/recherche/fiche/intranet/' + id , {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getAllSuivisListeContact(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/suivis/contacts/liste/contact/' + listeId ,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getAllSuivisListeContactPeriode(listeId, periodeDeb, periodeFin) {
    periodeDeb = periodeDeb.getFullYear() + '-' + (periodeDeb.getMonth() + 1) + '-' + periodeDeb.getDate() + ' 00:00:00' ;
    periodeFin = periodeFin.getFullYear() + '-' + (periodeFin.getMonth() + 1) + '-' + periodeFin.getDate() + ' 23:59:59' ;
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/suivis/contacts/liste/contact/periode/' + listeId + '/' + periodeDeb + '/' + periodeFin,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getDetailsContactsListe(listeId, dizaine) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/details/liste/contact/info/' + listeId + '/' + dizaine ,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getAllSuivisListeContactCritere(listeId, critere, structureChoisi) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/suivis/contacts/liste/contact/critere/' + listeId + '/' + critere + '/' + structureChoisi,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getAllSuivisUserListeContact(listeId, authUserId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/suivis/contacts/liste/contact/user/' + listeId + '/' + authUserId ,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getAllSuivisUserListeContactPeriode(listeId, periodeDeb, periodeFin, authUserId) {
    periodeFin = periodeFin.getFullYear() + '-' + (periodeFin.getMonth() + 1) + '-' + periodeFin.getDate() + ' 23:59:59' ;
    periodeDeb = periodeDeb.getFullYear() + '-' + (periodeDeb.getMonth() + 1) + '-' + periodeDeb.getDate() + ' 00:00:00' ;
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/suivis/contacts/liste/contact/periode/user/' + listeId + '/' + periodeDeb + '/'
      + periodeFin + '/' + authUserId,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getAllSuivisUserListeContactCritere(listeId, critere, structureChoisi, authUserId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/suivis/contacts/liste/contact/critere/user/' + listeId + '/' + critere + '/'
      + structureChoisi + '/' + authUserId,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getListesContactRechercheIntranet(recherche, type) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '/recherche/intranet/' + recherche + '/' + type , {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getListesContactsRecherche(recherche: Array<any>, page) {
    const content = recherche[0];
    let type = recherche[1];
    const headers = this.initOptionHeader();
    type = removeAccents(type.toLowerCase());
    if (type === 'tous') {
      return this.http.get(this.listeContactURL + '?several_all=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'nom') {
      return this.http.get(this.listeContactURL + '?liste_contact_nom=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'type') {
      return this.http.get(this.listeContactURL + '?liste_contact_type=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'gestionnaire') {
      return this.http.get(this.listeContactURL + '?liste_contact_gestion=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
  }
  exporterListeContactExcel(listeContactID, id, nom, prenom, civilite,  fonction,  contenu,  premierTel,  deuxiemeTel,  email,
                            rue,  complement,  bpostal,  cpostal,  ville,  pays,  premierURL,  deuxiemeURL,  societe,
                            telPro1,  telPro2,  emailPro,  support,  fonctionSupport,  telSupport,  emailSupport,
                            categorie,  objet,  dateConclu,  modeEnvoi,  piecesJointes, linkedin, twitter, facebook ) {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/liste_contacts/exportation/liste/contact/' + listeContactID + '/' +
      id + '/' + nom + '/' + prenom + '/' + civilite + '/' + fonction + '/' + contenu + '/' +
      premierTel + '/' + deuxiemeTel + '/' + email + '/' + rue + '/' + complement + '/' + bpostal + '/' +
      cpostal + '/' + ville + '/' + pays + '/' + premierURL + '/' + deuxiemeURL + '/' + societe + '/' + telPro1 + '/' +
      telPro2 + '/' + emailPro + '/' + support + '/' + fonctionSupport + '/' + telSupport + '/' + emailSupport + '/' +
      categorie + '/' + objet + '/'  + dateConclu + '/' + modeEnvoi + '/' + piecesJointes + '/' + linkedin
      + '/' + twitter  + '/' + facebook,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getAllListesContactsPar() {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '?order[nom]=asc&pagination=false', {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addListeContactContact(contactId, listeId) {
    const headers = this.initOptionHeader();
    return this.http.post(this.listeContactAssoURL, {
        'listeContact': this.listeContactURL + '/' + listeId,
        'contact': this.contactURL + '/' + contactId},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addGestionnaireListe(listeId, gestionnaireId) {
    const headers = this.initOptionHeader();
    return this.http.post(this.gestionnaireURL, {
        'listeContact': this.listeContactURL + '/' + listeId,
        'gestionnaire': Environement.BASE_API_URL + '/api/auth_users/' + gestionnaireId},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addAncienIdListeContact(ancienIdListe, listeId) {
    const headers = this.initOptionHeader();
    return this.http.put(this.listeContactURL + '/' +  listeId, {'ancienId': ancienIdListe},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getTypesListe() {
    const headers = this.initOptionHeader();
    return this.http.get(this.typeURL, {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListeContactIntranet(recherche) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactIntranetURL + recherche, {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  rechercheListeContact(champ) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeContactURL + '?liste_contact_nom=' + champ + '&pagination=false' + '&order[nom]=asc',
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  private errorHandler(err: any): Promise<any> {
    return Promise.reject(err.message || err );
  }
  private initOptionHeader() {
    const token: any = localStorage.getItem('auth-tokens');
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Auth-Token', token);
    return headers;
  }
}
